import React from "react";
import "../style/component/ResearchTable.css";

function ResearchTable({ researchs = [], headerTexts = [] }) {
  return (
    <section className="research-table-wrapper">
      <table className="research-table rounded">
        <thead>
          <tr>
            {headerTexts.map((header, index) => (
              <th key={index} scope="col">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {researchs.length > 0 ? (
            researchs.map((res, index) => (
              <tr key={res.id || index}>
                <td>{index + 1}</td>
                <td>{res.title}</td>
                <td>{res.abstract}</td>
                <td>{res.contributors}</td>
                <td>{res.startDate}</td>
                <td>{res.endDate}</td>
                <td>{res.funding}</td>
                <td>{res.notes}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td>1</td>
              <td>Coming soon</td>
              <td>Coming soon</td>
              <td>Coming soon</td>
              <td>Coming soon</td>
              <td>Coming soon</td>
              <td>Coming soon</td>
              <td>Coming soon</td>
            </tr>
          )}
        </tbody>
      </table>
    </section>
  );
}

export default ResearchTable;
